module.exports = "https://bce.bdstatic.com/video-meeting/zh-cn/assert/loading.596be6c2.gif";